export default "__VITE_ASSET__D$PujvFn__"